import createIcon from '../../createIcon';

/**
 * @component @name DirectionsBus
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAxNi41QzQgMTcuMzggNC4zOSAxOC4xNyA1IDE4LjcyVjIwLjVDNSAyMS4wNSA1LjQ1IDIxLjUgNiAyMS41SDdDNy41NSAyMS41IDggMjEuMDUgOCAyMC41VjE5LjVIMTZWMjAuNUMxNiAyMS4wNSAxNi40NSAyMS41IDE3IDIxLjVIMThDMTguNTUgMjEuNSAxOSAyMS4wNSAxOSAyMC41VjE4LjcyQzE5LjYxIDE4LjE3IDIwIDE3LjM4IDIwIDE2LjVWNi41QzIwIDMgMTYuNDIgMi41IDEyIDIuNUM3LjU4IDIuNSA0IDMgNCA2LjVWMTYuNVpNNy41IDE3LjVDNi42NyAxNy41IDYgMTYuODMgNiAxNkM2IDE1LjE3IDYuNjcgMTQuNSA3LjUgMTQuNUM4LjMzIDE0LjUgOSAxNS4xNyA5IDE2QzkgMTYuODMgOC4zMyAxNy41IDcuNSAxNy41Wk0xNi41IDE3LjVDMTUuNjcgMTcuNSAxNSAxNi44MyAxNSAxNkMxNSAxNS4xNyAxNS42NyAxNC41IDE2LjUgMTQuNUMxNy4zMyAxNC41IDE4IDE1LjE3IDE4IDE2QzE4IDE2LjgzIDE3LjMzIDE3LjUgMTYuNSAxNy41Wk0xOCAxMS41SDZWNi41SDE4VjExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsBus = createIcon('DirectionsBus', [
  [
    'path',
    {
      d: 'M4 16.5C4 17.38 4.39 18.17 5 18.72V20.5C5 21.05 5.45 21.5 6 21.5H7C7.55 21.5 8 21.05 8 20.5V19.5H16V20.5C16 21.05 16.45 21.5 17 21.5H18C18.55 21.5 19 21.05 19 20.5V18.72C19.61 18.17 20 17.38 20 16.5V6.5C20 3 16.42 2.5 12 2.5C7.58 2.5 4 3 4 6.5V16.5ZM7.5 17.5C6.67 17.5 6 16.83 6 16C6 15.17 6.67 14.5 7.5 14.5C8.33 14.5 9 15.17 9 16C9 16.83 8.33 17.5 7.5 17.5ZM16.5 17.5C15.67 17.5 15 16.83 15 16C15 15.17 15.67 14.5 16.5 14.5C17.33 14.5 18 15.17 18 16C18 16.83 17.33 17.5 16.5 17.5ZM18 11.5H6V6.5H18V11.5Z',
      key: 'xkoqiy',
    },
  ],
]);

export default DirectionsBus;
